import React from 'react';
import { Table, Button, ButtonToolbar, Glyphicon, Checkbox, Col, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../includes/custom/css/common.css';
import { adjustTables } from '../../includes/custom/js/tableScript';
import moment from 'moment';
import shipping from '../../includes/img/shipping.png';
import { formatCurrency, isNullOrEmpty, formatPlaceValue } from '../../utils/common';
import {
    DAY_KANA,
    EMPTY_COUNT,
    FIELD_CHECKBOX,
    FIELD_CHECKBOX_NAME,
    FIELD_PROPOSAL_DATE,
    DATE_FORMAT,
    EMPTY_STRING,
    ORDERPATTERN_CODE,
    FIELD_PRODUCT_PRICE,
    FIELD_PRODUCT_ORDER,
    ORDERCONTROL_SELECT,
    DEFAULT_PAGE_NUM,
    FIELD_SEND_DATETIME,
    DATETIME_FORMAT,
    ORDER_TABLE,
    PROPOSAL_NAME,
    ORDER_DL_CLOSED,
    FIELD_SHIPPING,
    MIN_DB_DATE_EXACT,
    MAX_DB_DATE_EXACT,
    FIELD_STRING_STARTDATE,
    FIELD_STRING_ENDDATE,
    FIELD_CHECKBOX_INDETERMINATE
} from '../../utils/constants';
import SelectInput from './SelectInput';


let isFirefox = typeof InstallTrigger !== 'undefined';

let TableTemplate = (props) => {
    var idColumns = []

    var tableClassName = props.tableName ? props.tableName : "defaultTable";

    adjustTables(tableClassName);

    //Renders table header
    const TableHeader = props.tableHeader && props.tableHeader.map((header, index) => {

        let headClass = "head" + index;
        let fixedHeaderClass = index === (props.tableHeader.length - DEFAULT_PAGE_NUM) ? "fixed-header lasthead" : "fixed-header";
        fixedHeaderClass += (header.center) ? " text-center" : ""
        fixedHeaderClass += (header.required) ? " required-input" : ""

        if (header.button) {
            return (<th key={index} className={fixedHeaderClass + " table-button-header"} id={headClass}><center>{header.label.split ('\n').map ((item, i) => <div key={i}>{item}<br/></div>)}</center></th>);
        } else if (header.checkbox) {
            return (<th key={index} className={fixedHeaderClass + " table-checkbox-header"} id={headClass}>
                {renderMainCheckbox(header.label)}
            </th>
            );
        } else if (header.id) {
            idColumns.push(index);
            return (<th key={index} className={fixedHeaderClass + " table-id"} id={headClass}>{header.label.split ('\n').map ((item, i) => <div key={i}>{item}<br/></div>)}</th>);
        } else {
            return (<th key={index} className={fixedHeaderClass} id={headClass}>{header.label}</th>);
        }
    });

    function renderMainCheckbox(label) {
        let hasSelected = EMPTY_COUNT < props.checkboxItems.length && props.tableList.length >= props.checkboxItems.length;

        return (
            <Checkbox
                id={FIELD_CHECKBOX_INDETERMINATE}
                checked={hasSelected}
                onChange={props.handleMainCheckboxChange.bind(this, hasSelected)}
                onClick={props.handleMainCheckboxChange.bind(this, hasSelected)}
                className="header-checklist"
            >
                {label}
            </Checkbox>
        )

    }

    //Renders table row
    function rowStyle(row) {
        let style = {}
        if (props.specialRow) {
            if (props.specialRow.notEqual) {
                if (row[props.specialRow.field] !== props.specialRow.value) {
                    style = { backgroundColor: props.specialRow.color }
                }
            } else if (props.specialRow.greaterThan) {
                if (row[props.specialRow.field] > props.specialRow.value) {
                    style = { backgroundColor: props.specialRow.color }
                }
            } else if (row[props.specialRow.field] === props.specialRow.value) {
                style = { backgroundColor: props.specialRow.color }
            }
        }

        if (props.proposalRow) {
            let formattedDate = moment().format(DATE_FORMAT);
            if (!moment(formattedDate).isBetween(row.strStartDate, row.strEndDate, null, '[]')
                && moment(row.strStartDate).isSameOrBefore(formattedDate)) {
                style = { backgroundColor: props.proposalRow.color }
            }
        }

        return style
    }

    const TableList = props.tableList && EMPTY_COUNT < props.tableList.length ? (
        props.tableList.map((row, i) => {
            return (
                <tr key={i} style={rowStyle(row)} >
                    {row.errorCd && (props.hasError && !(row.errorCd > 0)) ? null : RenderRow(row, i) }
                    {props.rowButtons ? RenderButtons(row, i) : null}
                </tr>
            );

        })
    ) : <tr><td className="col-center" colSpan={props.tableHeader.length}>表示するデータがありません。</td></tr>


    //Renders row data
    function RenderRow(data, rowIndex) {

        let rightAlignStyle = { textAlign: "right", paddingRight: "8px" };

        return (
            props.tableColumns.map((column, i) => {
                let colClass = "col" + i;
                let value = data.proposalId
                if (ORDER_TABLE === props.tableName) {
                    value += "♦" + data.closingDateTime + "♦" + data.proposalName + "♦" + data.deliveryDate + "♦" + data.shipping
                }
                // Checkbox
                if (FIELD_CHECKBOX === column) {
                    return (
                        <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="table-checkbox-header">
                            <Checkbox
                                className="table-checkbox"
                                onChange={props.handleCheckboxChange}
                                value={value}
                                name={FIELD_CHECKBOX_NAME}
                                checked={EMPTY_COUNT <= props.checkboxItems.indexOf(value)}
                            />
                        </td>
                    )
                }

                //Custom for Price Input
                if (FIELD_PRODUCT_PRICE === column || (FIELD_PRODUCT_ORDER === column)) {
                    let formattedValue = (FIELD_PRODUCT_PRICE === column) ? formatCurrency(data[FIELD_PRODUCT_PRICE]) : formatPlaceValue(data[FIELD_PRODUCT_ORDER]);
                    let priceValue = (FIELD_PRODUCT_PRICE === column) ? data[FIELD_PRODUCT_PRICE] : data[FIELD_PRODUCT_ORDER];
                    
                    return (
                        <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="table-price-header">
                            {props.isDisabled ? (
                                <p className="currency-column">
                                    {!isNullOrEmpty(formattedValue) && (FIELD_PRODUCT_PRICE === column ? `${formattedValue}円` : formattedValue)}
                                </p>
                            ) : (
                                    <span className={FIELD_PRODUCT_PRICE === column ? "custom-flex-end" : EMPTY_STRING}>
                                        <input
                                            id={rowIndex.toString()}
                                            className={FIELD_PRODUCT_PRICE === column ? "table-price-field" : "table-order-field"}
                                            onChange={props.handlePriceChange}
                                            placeholder={ formattedValue }
                                            step={data.multiple}
                                            name={FIELD_PRODUCT_PRICE}
                                            disabled={props.isDisabled}
                                            autoComplete="off"
                                            min={0} 
                                            onFocus={()=>{
                                                if(isFirefox){
                                                    document.getElementById(`${rowIndex.toString()}`).type = 'text';
                                                }else{
                                                    document.getElementById(`${rowIndex.toString()}`).type = 'number';
                                                }
                                                document.getElementById(`${rowIndex.toString()}`).value = priceValue;
                                            }}
                                            onBlur={()=>{
                                                document.getElementById(`${rowIndex.toString()}`).type = 'text';
                                                document.getElementById(`${rowIndex.toString()}`).value = formattedValue;
                                            }}
                                        />
                                        {FIELD_PRODUCT_PRICE === column && <p className="mr-15">円</p>}
                                    </span>
                                )}
                        </td>
                    );
                }

                //Custom for select order pattern
                if (ORDERCONTROL_SELECT === column) {
                    let orderControlCode = props.inputValues[rowIndex].orderControlCode;

                    return (
                        <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="pr-30 min-width-200">
                            <Col lg={12} style={{ padding: 0 }}>
                                <SelectInput
                                    id={rowIndex.toString()}
                                    className={"form-input mt-5"}
                                    name={ORDERPATTERN_CODE}
                                    value={null === orderControlCode ? EMPTY_STRING : orderControlCode}
                                    onChange={props.handlePatternChange}
                                    selectInput={props.selectInput}
                                    disabled={props.isDisabled}
                                    hideIcon={props.isDisabled}
                                    placeholder={props.selectPlaceholder}
                                />
                            </Col>
                        </td>
                    );
                }

                // Custom for Proposal Date
                if (FIELD_PROPOSAL_DATE === column) {
                    let startDate = moment(data[FIELD_STRING_STARTDATE]).format(DATE_FORMAT);
                    let endDate = moment(data[FIELD_STRING_ENDDATE]).format(DATE_FORMAT);
                    let strStart = MIN_DB_DATE_EXACT >= startDate ? EMPTY_STRING : startDate + " (" + DAY_KANA[moment(data[FIELD_STRING_STARTDATE]).day()] + ")  〜  ";
                    let strEnd = MAX_DB_DATE_EXACT <= endDate ? EMPTY_STRING :
                        (EMPTY_STRING === strStart ? " 〜 " + endDate : endDate) + " (" + DAY_KANA[moment(data[FIELD_STRING_ENDDATE]).day()] + ")"

                    return (
                        <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING}>
                            {strStart}
                            {strEnd}
                        </td>
                    );
                }

                // Custom for Send Date Time
                if (FIELD_SEND_DATETIME === column) {
                    let dateTimeValue = moment(data[FIELD_SEND_DATETIME]).format(DATETIME_FORMAT);
                    return (
                        <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="dateTimeRow">
                            {dateTimeValue}
                        </td>
                    );
                }

                // Custom for order shipping
                if (ORDER_TABLE === props.tableName && PROPOSAL_NAME === column && ORDER_DL_CLOSED === data[FIELD_SHIPPING]) {
                    return (
                        <td
                            key={i}
                            id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING}
                            className={EMPTY_COUNT <= idColumns.indexOf(i) ? ["table-id", props.tableHeader[i].headerClass] : props.tableHeader[i].headerClass}
                            style={props.tableHeader[i].rightAlign && rightAlignStyle}
                        >
                            <Image src={shipping} alt="shipping-icon" circle className="table-inline-icon" />
                            {'  '}
                            {data[column]}
                        </td>
                    )
                }

                // Custom for total amount
                if ("totalAmount" === column) {
                    return (
                        <td
                            key={i}
                            id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING}
                            className={EMPTY_COUNT <= idColumns.indexOf(i) ? ["table-id", props.tableHeader[i].headerClass] : props.tableHeader[i].headerClass}
                            style={props.tableHeader[i].rightAlign && rightAlignStyle}
                        >
                            {formatCurrency(data[column]) + "円"}
                        </td>
                    )
                }


                // Default
                return (
                    <td
                        key={i}
                        id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING}
                        className={EMPTY_COUNT <= idColumns.indexOf(i) ? ["table-id", props.tableHeader[i].headerClass] : props.tableHeader[i].headerClass}
                        style={props.tableHeader[i].rightAlign && rightAlignStyle}
                    >
                        <div className={props.tableHeader[i].contentClass}>
                            {data[column]}
                        </div>
                    </td>
                );
            })
        );
    }

    //Renders row buttons
    function RenderButtons(data, rowIndex) {
        const rowButtonStyle = {
            display: "flex",
            justifyContent: "center",
            marginLeft: "5px",

        };
        const buttonStyle = {
            marginTop: "0px"
        };

        return (
            props.rowButtons.map((button, i) => {
                let colClass = "col" + (props.tableHeader.length - props.rowButtons.length + i);
                return (
                    <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="table-button-header">
                        <ButtonToolbar style={rowButtonStyle}>
                            <Button
                                key={i}
                                style={buttonStyle}
                                bsStyle={button.bsStyle}
                                onClick={button.onClick.bind(this, data)}
                                disabled={props.isDisabled}
                            >
                                {button.icon && <FontAwesomeIcon icon={button.icon} size="2x" color="#000" />}
                                {button.glyph && <Glyphicon glyph={button.glyph} />}
                                {button.img && <Image src={button.img} alt="button-icon" className="img-icon" />}
                                {' '}
                                {button.label}
                            </Button>

                        </ButtonToolbar>
                    </td>
                )
            })
        )
    }

    return (
        <div className={tableClassName}>
            <div className={"thead-fixed table-responsive " + tableClassName}>
                <Table condensed hover bordered>
                    <thead className="table-header">
                        <tr>{TableHeader}</tr>
                    </thead>
                </Table>
            </div>

            <div className={"tbody-fixed table-responsive " + tableClassName} id={tableClassName}>
                <Table condensed hover striped bordered>
                    <tbody className="default-tbody">
                        {TableList}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default TableTemplate;